import {
  UtensilsCrossed,
  Compass,
  Wrench,
  Plane,
  Clapperboard,
  BookOpen,
  Tag,
} from 'lucide-react';

// The seven canonical categories, in their locked order.
export const CATEGORIES = [
  'Food & Drink',
  'Activities',
  'Services',
  'Travel',
  'Watch',
  'Books',
  'Other',
];

const ICONS = {
  'Food & Drink': UtensilsCrossed,
  Activities: Compass,
  Services: Wrench,
  Travel: Plane,
  Watch: Clapperboard,
  Books: BookOpen,
  Other: Tag,
};

export const categoryIcon = (category) => ICONS[category] || Tag;

// Each category has one locked accent token, used only for small cues.
const ACCENTS = {
  'Food & Drink': 'var(--cat-food)',
  Activities: 'var(--cat-activities)',
  Services: 'var(--cat-services)',
  Travel: 'var(--cat-travel)',
  Watch: 'var(--cat-watch)',
  Books: 'var(--cat-books)',
  Other: 'var(--cat-other)',
};

// Returns the inline style that exposes the accent to CSS as --cat-accent.
export const categoryAccentStyle = (category) =>
  ACCENTS[category] ? { '--cat-accent': ACCENTS[category] } : undefined;

// Locked examples. They demonstrate the behaviour we want: don't just say what
// is good, say the useful thing someone should know about it.
export const CATEGORY_EXAMPLES = {
  'Food & Drink': {
    what: 'The Store, Britomart',
    why: "The salmon eggs benedict is a must-try — the best I've tasted in Auckland.",
  },
  Activities: {
    what: 'Rangitoto Island summit walk',
    why: "Take the earliest ferry and do the summit first — you'll beat most of the crowds and have time to explore the lava caves on the way back.",
  },
  Services: {
    what: 'My Auto Shop',
    why: 'Ask for Sam — he explains what actually needs fixing before doing any work and never pressures you into extras.',
  },
  Travel: {
    what: 'Manase, Savaiʻi',
    why: "Stay in a beach fale for at least one night — falling asleep beside the ocean and waking up right on the beach is an experience you won't get from a hotel.",
  },
  Watch: {
    what: 'The Bear',
    why: "Watch the first three episodes before deciding — it's intense at first, but the characters and family story really start to land.",
  },
  Books: {
    what: 'Atomic Habits',
    why: 'Try habit stacking: after you make your morning coffee, read 5 pages of a book. Linking the new habit to something you already do makes it easier to stick with.',
  },
  Other: {
    what: 'Take a photo of your luggage before checking in',
    why: "If your bag goes missing, you've got a current photo showing exactly what it looks like, which makes reporting it much easier.",
  },
};

// Shown before a category is chosen, so no example ever belongs to another category.
export const NEUTRAL_EXAMPLE = {
  what: 'A place, product, show, book or tip…',
  why: 'Tell people the useful thing they should know about it.',
};

export const categoryExample = (category) => CATEGORY_EXAMPLES[category] || NEUTRAL_EXAMPLE;
